// The `?login_error=<code>` an API sign-in leg bounces a failed navigation to
// (`dashboardError` in apps/api `routes/org-sso.ts`, `github-auth/flow.ts`,
// `routes/auth.ts`, `auth-legs.ts`). It has TWO readers, and this is their one
// mapping: <Login/> for a signed-out landing, and <LoginErrorNotice/> in the
// shell for a signed-in one (an SSO link or a second sign-in that failed while
// a session was already live renders the app, never <Login/>).

import { t } from '../i18n';

/** The query param the API sets. */
export const LOGIN_ERROR_PARAM = 'login_error';

/**
 * #787: a known code's specific sentence (`login.error_code.<code>`); an
 * unknown code falls back to the generic retry line. Presence via `t.has` so
 * this cannot drift on the translator's miss-marker shape (#790).
 */
export function loginErrorMessage(code: string): string {
  const key = `login.error_code.${code}`;
  return t.has(key) ? t(key) : t('login.error');
}
